import * as React from 'react';
import {
  Label as HeadlessRadioGroupLabel,
  Radio as HeadlessRadioGroupOption
} from '@headlessui/react';
import { FComponent } from '../../../types/common';
import { classNames } from '../../../utils';
import { ZoomableImage } from '../ZoomableImage';

export type RadioGroupOptionProps = {
  value: string;
  label: string;
  imageUrl: string;
  ariaLabel?: string;
};

const ImageRadioGroupOption: FComponent<RadioGroupOptionProps> = ({
  value,
  label,
  imageUrl,
  ariaLabel
}) => {
  return (
    <HeadlessRadioGroupOption value={value} className="image-radiogroup-option">
      {({ focus, checked }) => (
        <div
          className={classNames(
            focus && 'radiogroup-option-active',
            checked && 'radiogroup-option-checked',
            'radiogroup-option-simple'
          )}>
          <HeadlessRadioGroupLabel as="div" className="option-label">
            <ZoomableImage src={imageUrl} alt={ariaLabel} />
            <div className="radio-button" />
            {label ? <div className="cell-label">{label}</div> : null}
          </HeadlessRadioGroupLabel>
        </div>
      )}
    </HeadlessRadioGroupOption>
  );
};

export { ImageRadioGroupOption };
